import { HttpErrorResponse } from "@angular/common/http";

export interface ResetMFAState {
  resetMfaLoader: boolean;
  resetMfaResult: boolean | null;
  hasMfa: boolean;
  resetMfaError: HttpErrorResponse;
};

export const initialResetMFAState: ResetMFAState = {
  resetMfaLoader: false,
  resetMfaResult: null,
  hasMfa: false,
  resetMfaError: null
};